module.exports = __webpack_public_path__ + "img/pepper-hot.0ba51b44.svg";